import { render } from "./App.vue?vue&type=template&id=a000312e&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a000312e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/soilfood.com/soilfood.com/vue/oma-myyja/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a000312e"]])

export default __exports__